// src/constants.js

export const PHASES = [
  { id: 'access',    label: 'Access & Deliverables',  color: '#E24B4A' },
  { id: 'analysis',  label: 'Analysis',               color: '#BA7517' },
  { id: 'building',  label: 'Building',               color: '#185FA5' },
  { id: 'built',     label: 'Built (waiting on items)',color: '#7F77DD' },
  { id: 'tracking',  label: 'Tracking',               color: '#1D9E75' },
  { id: 'qa',        label: 'Q/A',                    color: '#639922' },
  { id: 'prelaunch', label: 'Prelaunch',              color: '#0F6E56' },
  { id: 'postlaunch',label: 'Launched',               color: '#0F6E56' },
  { id: 'cancelled', label: 'Cancelled / Non-Start',  color: '#888888' },
];

export const PHASE_COLORS = {
  access:    { bg: '#FCEBEB', text: '#A32D2D' },
  analysis:  { bg: '#FAEEDA', text: '#854F0B' },
  building:  { bg: '#E6F1FB', text: '#185FA5' },
  built:     { bg: '#EEEDFE', text: '#3C3489' },
  tracking:  { bg: '#E1F5EE', text: '#0F6E56' },
  qa:        { bg: '#EAF3DE', text: '#3B6D11' },
  prelaunch: { bg: '#dcf0e8', text: '#0F6E56' },
  postlaunch:{ bg: '#dcf0e8', text: '#0F6E56' },
  cancelled: { bg: '#f0f0ee', text: '#666664' },
};

export const PLATFORMS = ['Google Ads', 'Microsoft', 'LSA', 'Meta', 'Yelp', 'Nextdoor'];
export const LP_PLATFORMS = ['Google Ads', 'Microsoft', 'Meta'];

export const PLAT_DELIVERABLES = {
  'Google Ads': [
    '__ACCESS__','Budget','Priority Services','Geo Targeting',
    'Ad Schedule','Ads Destination','Value Props','Forward To #\'s',
    'Credit Card','Add Payment User',
    'Verifications','Ingestion Sheet Updated','Salesforce Updated'
  ],
  'Microsoft': [
    '__ACCESS__','Budget','Priority Services','Geo Targeting',
    'Ad Schedule','Ads Destination','Value Props','Forward To #\'s',
    'Credit Card','Ingestion Sheet Updated','Salesforce Updated'
  ],
  'LSA': [
    '__ACCESS__','Budget','Service Area','Business Hours',
    'Ad Schedule','Credit Card','Forward To #\'s','Photos','Verifications',
    'COI','Licensing','Add Payment User','Ingestion Sheet Updated','Salesforce Updated'
  ],
  'LSA_new': [
    'Create New LSA Account','Budget','Service Area','Business Hours',
    'Ad Schedule','Credit Card','Forward To #\'s','Photos','Verifications',
    'COI','Licensing','Business Registration','Owner Name','Owner Email',
    'Add Payment User','Ingestion Sheet Updated','Salesforce Updated'
  ],
  'Meta': [
    '__ACCESS__','Budget','Priority Services','Geo Targeting',
    'Value Props','Photos / Creative Assets','Logos','Forward To #\'s',
    'Coupons/Promos','Credit Card',
    'Ingestion Sheet Updated','Salesforce Updated'
  ],
  'Yelp': [
    '__ACCESS__','Budget','Priority Services','Service Area',
    'Business Hours','Photos','Coupons/Promos','Credit Card',
    'Ingestion Sheet Updated','Salesforce Updated'
  ],
  'Nextdoor': [
    '__ACCESS__','Budget','Priority Services','Service Area',
    'Business Hours','Photos','Credit Card',
    'Ingestion Sheet Updated','Salesforce Updated'
  ],
};

export const LP_DELIVERABLES = [
  'Value Props','F/R #\'s','Coupons/Promos','Form Contact Email',
];

export const LP_STEPS = [
  'Fill out LP Build Template',
  'Order Sanity Project',
  'Order DES Assets',
  'Request Landing Pages be created',
  'Landing Page Review',
  'Landing Pages Approved',
];

export const TRACK_STEPS = [
  'Gather tracking deliverables',
  'Fill out Tracking Table',
  'Tag tracking team',
  'Tracking ordered/started',
  'Paid Media Tracking setup',
  'Tracking Q/A complete',
];

export const PM_STEPS = [
  'New Client Email',
  'Post-Sales Call',
  'Paid Media Survey',
  'Website Survey',
  'Paid Media Analysis',
  'Kick-off Call',
  'Critical for Launch Surveys',
  'Follow Up Strategy Call',
  'Internal Pre-Launch Call',
  'Pre-Launch Client Call',
  'Launch Scheduled',
  'Launch Email Sent',
];

export const ADS_DESTINATIONS = ['Landing Pages', 'Website', 'IMO Website', 'Misc.'];

export const VERTICALS = [
  'HVAC',
  'Plumbing',
  'Water Mitigation',
  'Sewer & Drain',
  'Electrical',
  'Solar',
  'Roofing',
  'Siding',
  'Windows',
  'Doors',
  'Garage Doors',
  'Landscaping',
  'Pest Control',
  'Remodeling',
  'Restorations',
];

// Extra deliverables added when Garage Doors vertical is selected
export const GARAGE_DOOR_DELIVERABLES = {
  'Google Ads': [
    'Advanced Verification: Business Registration',
    'Advanced Verification: Owner Full Name',
    'Advanced Verification: Owner Email',
    'Advanced Verification: Vertical License',
  ],
  'LSA': [
    'Advanced Verification: Business Registration',
    'Advanced Verification: Owner Full Name',
    'Advanced Verification: Owner Email',
    'Advanced Verification: Vertical License',
  ],
  'LSA_new': [
    'Advanced Verification: Business Registration',
    'Advanced Verification: Owner Full Name',
    'Advanced Verification: Owner Email',
    'Advanced Verification: Vertical License',
  ],
};

export function resolveLabel(d, aType) {
  if (d === '__ACCESS__') return aType === 'new' ? 'Create New Account' : 'Access to Existing Account';
  return d;
}

export function platShort(n) {
  return { 'Google Ads': 'GAds', Microsoft: 'MSFT', LSA: 'LSA', Meta: 'Meta', Yelp: 'Yelp', Nextdoor: 'Nextdoor' }[n] || n;
}

export function platColor(n) {
  return {
    'Google Ads': { bg: '#E6F1FB', text: '#0C447C' },
    Microsoft:    { bg: '#E1F5EE', text: '#085041' },
    LSA:          { bg: '#EAF3DE', text: '#27500A' },
    Meta:         { bg: '#EEEDFE', text: '#3C3489' },
    Yelp:         { bg: '#FAECE7', text: '#712B13' },
    Nextdoor:     { bg: '#FAEEDA', text: '#633806' },
  }[n] || { bg: '#eee', text: '#333' };
}

export function newPlatform(name) {
  return {
    name,
    budget: '',
    feePercent: '',
    accountType: 'new',
    accessGranted: false,
    cid: '',
    notes: '',
    facebookPageUrl: '',
    metaPixelStatus: '',
    built: false,
    posted: false,
    launched: false,
    launchDate: '',
    live: false,
    auditDone: false,
    deliverables: {},
    lpDeliverables: {},
    lpDelivEnabled: true,
    lpSectionOpen: true,
  };
}

export function newClient(ownerUid, ownerName) {
  return {
    id: Date.now().toString(36) + Math.random().toString(36).slice(2),
    ownerUid,
    ownerName,
    name: '',
    cids: '',
    vertical: '',
    verticals: [],
    adsDestination: '',
    csm: '',
    pm: '',
    strategist: '',
    phase: 'access',
    wrinkleLink: '',
    analysisLink: '',
    adCopyDocLink: '',
    metaDesignAssetsLink: '',
    salesforceLink: '',
    lpBuildTemplateLink: '',
    websiteUrl: '',
    gbpLink: '',
    opsSpecialist: '',
    formContactEmail: '',
    businessHours: '',
    legalBusinessName: '',
    surveyNotes: '',
    specialNotesLaunch: '',
    onboardingAnalysisContent: '',
    surveys: {},
    mrrAmount: '',
    accountPoc: '',
    pocEmail: '',
    valueProps: '',
    couponsPromos: '',
    notes: '',
    pinNote: '',
    kickoff: '',
    projLaunch: '',
    actualLaunch: '',
    lastChecked: '',
    postSaleCallDate: '',
    surveysCompletedDate: '',
    allDeliverablesReceivedDate: '',
    lpOrderedDate: '',
    lpCompletedDate: '',
    lpApprovedDate: '',
    buildPostedDate: '',
    trackingCompletedDate: '',
    paidTrackingCompletedDate: '',
    paidTrackingCompletedBy: '',
    lsaDatesEnabled: false,
    lsaKickoffDate: '',
    lsaSurveysCompletedDate: '',
    lsaTrackingCompletedDate: '',
    lsaPaidTrackingCompletedDate: '',
    lsaPaidTrackingCompletedBy: '',
    lsaLaunchDate: '',
    onHold: false,
    important: false,
    opspm: false,
    pmNotes: '',
    lpEnabled: false,
    lpBuildOpen: true,
    platforms: [newPlatform('Google Ads')],
    lpSteps: {},
    trackSteps: {},
    pmSteps: {},
    adScheduleNotes: '',
    serviceAreaNotes: '',
    phoneNumbers: '',
    campaignStructure: '',
    adsWebsiteUrls: '',
    adsLpUrls: '',
    createdAt: Date.now(),
    updatedAt: Date.now(),
  };
}
